import { render, staticRenderFns } from "./InvoiceMain.vue?vue&type=template&id=2fa61828&scoped=true&"
import script from "./InvoiceMain.vue?vue&type=script&lang=js&"
export * from "./InvoiceMain.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceMain.vue?vue&type=style&index=0&id=2fa61828&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa61828",
  null
  
)

export default component.exports